import * as log from 'loglevel'
import App from './App.vue'
import Highcharts from 'highcharts'
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import VueHighcharts from 'vue-highcharts'
import axios from 'axios'
import lang from 'element-ui/lib/locale/lang/en'
import loadMore from 'highcharts/highcharts-more'
import locale from 'element-ui/lib/locale'
import router from './router'
import store from './store'
import vueTopprogress from 'vue-top-progress'
import { get } from 'lodash'
import { sync } from 'vuex-router-sync'
import {
  Badge,
  Button,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Collapse,
  CollapseItem,
  DatePicker,
  Dialog,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Form,
  FormItem,
  Input,
  InputNumber,
  Loading,
  Message,
  MessageBox,
  Option,
  Popover,
  Radio,
  RadioButton,
  RadioGroup,
  Select,
  Slider,
  Step,
  Steps,
  Switch,
  TabPane,
  Tabs,
  Tag,
  Tooltip
} from 'element-ui'

log.setLevel('info')
log.info('main.js', Vue)
Object.defineProperty(Vue.prototype, '$log', { value: log })

// configure language
locale.use(lang)
// Vue.use(ElementUI, {locale})

// Dependencies for http://element.eleme.io/
Vue.use(Badge)
Vue.use(Button)
Vue.use(Checkbox)
Vue.use(CheckboxButton)
Vue.use(CheckboxGroup)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(DatePicker)
Vue.use(Dialog)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Option)
Vue.use(Popover)
Vue.use(Radio)
Vue.use(RadioButton)
Vue.use(RadioGroup)
Vue.use(Select)
Vue.use(Slider)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Switch)
Vue.use(TabPane)
Vue.use(Tabs)
Vue.use(Tag)
Vue.use(Tooltip)

Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
// Notification does not exist in some browsers(e.g. mobile brosers)
// if (Notification) {
//   Vue.prototype.$notify = Notification
// }
Vue.prototype.$message = Message

// Dependencies for highcharts
loadMore(Highcharts)
Vue.use(VueHighcharts, { Highcharts })

// Dependencies for top-progress

Vue.use(vueTopprogress)

// Vue router set-up
sync(store, router)

Vue.use(VueAnalytics, {
  id: 'UA-115351934-1',
  checkDuplicatedScript: true,
  router
})

// Axios intercepts for Unauthorized access (401) and Maintenance (503)

function promptRedirect() {
  try {
    MessageBox.alert(
      'You probably need to re-login or you are not authorised to use SWARM on this problem. Please contact administrators for further explanation',
      'Failed authentication or authorization',
      {
        confirmButtonText: 'OK',
        callback: action => {
          let url = store.state.platform['T&E Portal URL']
          if (url) {
            window.location.href = url
          }
        }
      }
    )
  } catch (e) {
    // pass
  }
}

axios.interceptors.response.use(
  response => {
    return response
  },
  function(error) {
    let authProvider
    try {
      authProvider = store.getters.authProvider
      log.info('Interceptors - 401 - authProvider', authProvider)
    } catch (e) {
      // pass
    }
    // TO DO:
    // Differentiate between error invoked from ajax calls or router changes
    // (between action to add/change content or navigational change)
    let errorCode = get(error, 'response.status', -1)
    if (errorCode === 401 && error.config && !error.config.__isRetryRequest) {
      log.info('Interceptors - 401', router, router.history.current.fullPath)
      error.config.__isRetryRequest = true
      return store
        .dispatch('getNewAccessToken')
        .then(function(newAccessToken) {
          if (!newAccessToken) { // no token is returned, please do nothing
            return
          }
          error.config.headers.Authorization = newAccessToken
          return axios.request(error.config)
        })
        .catch(function(err) {
          log.info('Interceptors - 401 error', err)
          store
            .dispatch('logout')
            .then(function() {
              if (authProvider !== 'tne') {
                router.push('/login')
              } else {
                promptRedirect()
              }
            })
            .catch(function() {
              if (authProvider !== 'tne') {
                router.push('/login')
              } else {
                promptRedirect()
              }
            })
        })
    } else if (errorCode === 503) {
      router.push('/maintenance')
    }
    return Promise.reject(error)
  }
)

Vue.config.productionTip = false

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  ...App
})

export { app, router, store }
